// Every round/match this module generates gets one of these as its `id` —
// a real GUID, not a composite string built from position (leg/round/index)
// or label. Positional ids look unique within whichever single generator
// call produced them, but several formats call the SAME generator more than
// once (group_knockout/ladder run round-robin once per group/court) and then
// merge the results into one shared list (group_knockout's "Full Schedule"
// view) — at that point two entirely different matches can end up with the
// identical positional id, and every gear-icon override keyed by that id
// (see scheduleRows.js's row.key / MatchTable's round keying) silently
// applies to both. A GUID can't collide across separate calls, so this is
// the actual fix rather than another prefix to keep track of.
//
// This also matters beyond this prototype: once a schedule is saved (see
// useScheduleBuilder.js's doc comment on KYN-475), each of these rounds and
// matches becomes a real row in the tournament_rounds/tournament_matches
// tables. Generating the real id client-side, now, means that same value can
// become the row's actual primary key at save time — the override data this
// module already builds keys by id, so nothing needs remapping once it's a
// DB record instead of a localStorage entry.
export const newId = () => crypto.randomUUID();
